import { render } from "./ReferencesSelect.vue?vue&type=template&id=3edc2468&scoped=true"
import script from "./ReferencesSelect.vue?vue&type=script&lang=js"
export * from "./ReferencesSelect.vue?vue&type=script&lang=js"

import "./ReferencesSelect.vue?vue&type=style&index=0&id=3edc2468&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edc2468"]])

export default __exports__